import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M30.9998 14.5752V16.0752C30.9847 19.1027 30.0537 22.0547 28.3294 24.5432C26.6051 27.0317 24.1681 28.9402 21.3389 30.0177C18.5096 31.0953 15.4205 31.2915 12.4776 30.5806C9.53476 29.8696 6.8759 28.2848 4.8506 26.0345C2.8253 23.7841 1.52835 20.9736 1.13025 17.9724C0.73216 14.9712 1.25156 11.9197 2.62016 9.21918C3.98877 6.51867 6.14252 4.2955 8.79828 2.84194C11.454 1.38837 14.4875 0.772467 17.4998 1.07518M9.99982 19.0752C9.99982 19.0752 12.2498 22.0752 15.9998 22.0752C19.7498 22.0752 21.9998 19.0752 21.9998 19.0752M11.4998 11.5752H11.5148M20.4998 11.5752H20.5148M21.9998 5.57518H30.9998M26.4998 1.07518V10.0752",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }